<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-plus`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.718 4c.446 0 .608.046.77.134a.906.906 0 01.378.378c.088.163.134.324.134.77V22h16.718c.446 0 .607.046.77.134a.906.906 0 01.378.378c.088.162.134.324.134.77v1.436c0 .446-.046.608-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134H26v16.718c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.162.088-.324.134-.77.134h-1.436c-.446 0-.608-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.163-.134-.324-.134-.77L21.999 26H5.282c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77v-1.436c0-.446.046-.608.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134L22 21.999V5.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134h1.436z"/></svg>
</template>
<script>

export default {
  name: 'IconPlus',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
